function SettingFileSendDelayPage(props) {
  const { lang, toast, business_data } = props;

  const [isEnabled, setIsEnabled] = React.useState(false);
  const [savedEnabled, setSavedEnabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isUpdating, setIsUpdating] = React.useState(false);

  React.useEffect(() => {
    getSettings();
  }, []);

  const getSettings = () => {
    axios({
      method: "post",
      url:
        backend +
        "app/" +
        business_data.uid +
        "/" +
        business_data.pid +
        "/settings",
      headers: {
        "Content-type": "application/json;charset=UTF-8",
        "X-VC-Access-Token": business_data.access,
        Authorization: "Bearer " + business_data.token,
      },
      data: {
        appId: business_data.app_id,
      },
    }).then((res) => {
      if (res.data.result === 0) {
        // Contract: unlike the removed delay_send_message_duration (a number, 0 = off),
        // file_send_delay_enabled is a real boolean on GET, defaulting to false server-side
        // when never configured (lib/v4/app.js). Coerce defensively anyway in case an older
        // backend deploy omits the field entirely.
        const enabled = !!_.get(res.data.data, ["settingInfo", "file_send_delay_enabled"]);
        setIsEnabled(enabled);
        setSavedEnabled(enabled);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(lang.__setting_get_fail);
      }
    }, () => {
      setIsLoading(false);
      toast.error(lang.__setting_get_fail);
    });
  };

  // Cancel restores the last saved value without making a request.
  const cancel = () => {
    setIsEnabled(savedEnabled);
  };

  // Save writes through the existing app settings API and reports success/failure.
  // File-hold has no duration control (always a fixed, non-configurable 30s server-side),
  // so this only ever writes the on/off flag.
  const save = () => {
    const enabledToSave = !!isEnabled;
    setIsUpdating(true);
    axios({
      method: "put",
      url:
        backend +
        "app/" +
        business_data.uid +
        "/" +
        business_data.pid +
        "/settings",
      headers: {
        "Content-type": "application/json;charset=UTF-8",
        "X-VC-Access-Token": business_data.access,
        Authorization: "Bearer " + business_data.token,
      },
      data: JSON.stringify({
        appId: business_data.app_id,
        info: { file_send_delay_enabled: enabledToSave },
      }),
    }).then((res) => {
      setIsUpdating(false);
      if (res.data.result === 0) {
        setSavedEnabled(enabledToSave);
        toast.success(lang.__setting_update_successfully);
      } else {
        toast.error(lang.__setting_update_fail);
      }
    }, () => {
      setIsUpdating(false);
      toast.error(lang.__setting_update_fail);
    });
  };

  return (
    <div style={{ height: "100%" }}>
      {isLoading ? (
        <div class="sp-placeholder">
          <div class="sp-text-help">
            <i class="icon icon-circle-notch animate-spin"></i>{" "}
            <span>{lang.__loading}</span>
          </div>
        </div>
      ) : (
        <div className="file-send-delay-page">
          <div className="header">
            <div className="sp-label">{lang.__file_send_delay_setting_title}</div>
            <div className="sp-text-help">{lang.__file_send_delay_setting_subtitle}</div>
          </div>
          <div className="body sp_margin">
            <div class="sp-section">
              <div class="sp-row">
                <div class="sp-col">
                  <p class="sp-label">{lang.__file_send_delay_setting_toggle_label}</p>
                  <p class="sp-text-help">{lang.__file_send_delay_setting_toggle_description}</p>
                </div>
                <div class="sp-col -align-right -wrap">
                  <div className={"sp-toggle" + (!isEnabled ? " -off" : "")}>
                    <label>
                      <input
                        type="checkbox"
                        checked={!!isEnabled}
                        onChange={(e) => setIsEnabled(e.target.checked)}
                      />
                      <div className="toggle-button cursor-pointer"><span></span></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer">
            <button class="sp-btn -link" onClick={() => cancel()}>
              {lang.__cancel}
            </button>
            <button class="sp-btn -blue" onClick={() => save()} disabled={isUpdating}>
              {isUpdating && <i class="icon-circle-notch animate-spin"></i>}
              <span>{lang.__save}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
